import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router'
import { DataService } from './shared/dataservice.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
   public options = {
        position: ["top", "right"],
        timeOut: 5000,
        lastOnBottom: true,
        showProgressBar:true,
        clickToClose:true
    };

  constructor(private activeRoute:ActivatedRoute,private route:Router,public _dataService:DataService){
     this.checkforRedirect();  
  }

  checkforRedirect(){
    this.activeRoute.queryParams.subscribe((params:Params) => {
        if(params['rurl'] && params['rurl'] != ''){
          var url:string = params['rurl'];
          this.route.navigateByUrl(decodeURIComponent(url));
        }
    });
  }

  ngOnInit(){
   
  }

  onRightClick(_evnt){
    return false;
  }
}
